import { Link } from 'react-router-dom'
import { ArrowLeft, ChevronRight } from 'lucide-react'
import { SECTIONS } from '../data/adminSections'

/**
 * The front door: three choices, not eleven.
 *
 * Everything in the admin is either somebody you are training, something you
 * are training them with, or help doing it — so the first decision is which of
 * those you are here for, and the tabs for the rest stay out of the way until
 * you have made it.
 *
 * Each card counts what is behind it rather than only naming it, because "how
 * many courses are there" is the sort of question people open a section to
 * answer and then leave again.
 */
export default function AdminHubPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <Link
        to="/modules"
        className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-gray-500 transition-colors hover:text-gray-900"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to modules
      </Link>

      <h1 className="text-3xl font-bold text-gray-900">Training Admin</h1>
      <p className="mt-1 text-sm text-gray-500">
        Finder University — degrees, the courses they are built from, and the crew doing them.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SECTIONS.map((section) => {
          const Icon = section.icon
          return (
            <Link
              key={section.id}
              to={section.pages[0].to}
              className="group flex flex-col rounded-2xl border border-gray-200 bg-white p-6 shadow-xs transition-all hover:border-purple-300 hover:shadow-md focus-visible:border-purple-400"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-purple-50 text-purple-600 transition-colors group-hover:bg-purple-100">
                <Icon className="h-5 w-5" />
              </div>

              <h2 className="mt-4 flex items-center gap-1 text-lg font-bold text-gray-900">
                {section.name}
                <ChevronRight className="h-4 w-4 text-gray-300 transition-transform group-hover:translate-x-0.5 group-hover:text-purple-500" />
              </h2>
              <p className="mt-1 text-sm text-gray-500">{section.blurb}</p>

              <ul className="mt-4 flex flex-wrap gap-1.5 border-t border-gray-100 pt-4">
                {section.pages.map((page) => (
                  <li
                    key={page.to}
                    className="rounded-md bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-600"
                  >
                    {page.label}
                  </li>
                ))}
              </ul>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
